import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Avatar,
  Box,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./profile.css";
import Navbar from "./navbar_landingpage";
import axios from "axios";
import { supabase } from "./db"; // Adjust the import path as necessary

/** Appends a cache-bust param so the browser reloads after same-URL uploads (Supabase upsert). */
function profileImageSrc(url, cacheKey) {
  if (!url) return "";
  if (!cacheKey) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("v", String(cacheKey));
    return u.toString();
  } catch {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}v=${cacheKey}`;
  }
}

export default function Profile() {
  const [activeTab, setActiveTab] = useState("profile");
  const [profilePicUrl, setProfilePicUrl] = useState("");
  const [avatarCacheKey, setAvatarCacheKey] = useState(0);
  const userRole = localStorage.getItem("role");

  const [profile, setProfile] = useState({
    name: "",
    email: "",
    designation: "",
    password: "",
    newpassword : "",
    confirmPassword: "",
    address: "",
    gender: "",
    contact_no: "",
    image_url: "",
  });

  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    password: "",
    access_role: "general",
  });

  const [showConfirm, setShowConfirm] = useState(false);

  const handleImageUpload = async (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    
    try {
      const { data, error } = await supabase.storage
      .from('media')  // Use the correct bucket name: 'media'
      .upload(`public/${file.name}`, file, {
          upsert: true, // Update the file if it already exists
        }
      ); 

    if (error) {
      console.error("Upload failed:", error.message);
      return;
    }
    const urlData = supabase.storage.from("media").getPublicUrl(`public/${file.name}`);
    const publicUrl = urlData.data.publicUrl;

    setProfilePicUrl(publicUrl);
    setProfile((prev) => ({ ...prev, image_url: publicUrl }));
    setAvatarCacheKey(Date.now());

    await updateImageInDB(type, publicUrl);
    await getProfile();
    setAvatarCacheKey(Date.now());

    if (event.target) event.target.value = "";
    } catch (error) {
      console.error(`Upload failed for ${type} picture:`, error);
      await getProfile();
    }
  };


  const updateImageInDB = async (type, imageUrl) => {
    console.log("imageUrl",imageUrl);
    const token = localStorage.getItem("token");
    

    try {
      await axios.put(
        "https://warpo-dashboard.cse.buet.ac.bd/api/profile/update-pic",
          {imageUrl},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log(`${type} image updated in database.`);
    } catch (error) {
      console.error(`Failed to update ${type} image in DB:`, error);
      throw error;
    }
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleNewUserChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prev) => ({ ...prev, [name]: value }));
  };

  const getProfile = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get("https://warpo-dashboard.cse.buet.ac.bd/api/profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setProfile(response.data.user);
      console.log("Profile data:", response.data.user); // Log the profile data
      setProfilePicUrl(response.data.user.image_url); // Set the profile picture URL
      console.log("Profile picture URL:", response.data.user.image_url); // Log the profile picture URL
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  const handleSaveProfile = async () => {
    const token = localStorage.getItem("token");
    if (profile.newpassword !== profile.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    else{
      profile.password = profile.newpassword;
    }
    if (!profile.name || !profile.email || !profile.designation ){
      alert("Please fill all fields");
      return;
    }
    console.log("Profile data to save:", profile); // Log the profile data before sending it to the server
    try {
      await axios.put(
        "https://warpo-dashboard.cse.buet.ac.bd/api/edit-user",
        profile,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("Profile updated successfully!");
      setShowConfirm(false);
      getProfile();
      setShowPasswordFields(false);
      setShowNewPassword(false);
      setShowConfirmPassword(false);
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Error updating profile. Please try again.");
    }
  };

  const handleAddUser = async () => {
    if (!newUser.name || !newUser.email || !newUser.password || !newUser.access_role) {
      alert("Please fill all fields");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.post("https://warpo-dashboard.cse.buet.ac.bd/api/create-user", newUser, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      alert("New user added successfully!");
      setNewUser({
        name: "",
        email: "",
        password: "",
        acess_role: "",
      });
    } catch (error) {
      console.error("Error adding user:", error);
      alert("Failed to add user");
    }
  };
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

const getAllUsers = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get("https://warpo-dashboard.cse.buet.ac.bd/api/all-users", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    setUsers(response.data.data); // Assuming the response has a 'users' array
    console.log("Users:", response.data.data); // Log the users data
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

useEffect(() => {
  if (activeTab === "allUsers") {
    getAllUsers(); // Fetch users when the "All Users" tab is active
  }
}, [activeTab]);


// // Handle selection of users
// const handleSelectUser = (userId) => {
//   setSelectedUsers((prevSelectedUsers) => {
//     if (prevSelectedUsers.includes(userId)) {
//       return prevSelectedUsers.filter((user_id) => user_id !== userId); // Deselect user
//     } else {
//       return [...prevSelectedUsers, userId]; // Select user
//     }
//   });
// };


// // Delete selected users
// const handleDeleteSelectedUsers = async () => {
//   const token = localStorage.getItem("token");
//   try {
//     for (const userId of selectedUsers) {
//       await axios.delete(`https://warpo-dashboard.cse.buet.ac.bd/api//delete-user/${userId}`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//     }
//     alert("Selected users deleted successfully!");
//     // Remove deleted users from the state
//     getAllUsers();
//     setSelectedUsers([]); // Clear selected users after deletion
//   } catch (error) {
//     console.error("Error deleting users:", error);
//     alert("Failed to delete selected users.");
//   }
// };


// Delete a single user
const handleDeleteUser = async (userId) => {
  const token = localStorage.getItem("token");
  try {
    await axios.delete(`https://warpo-dashboard.cse.buet.ac.bd/api/delete-user/${userId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    alert("User deleted successfully!");
    // Remove deleted user from the state
    getAllUsers();
    
  } catch (error) {
    console.error("Error deleting user:", error);
    alert("Failed to delete user.");
  }
}
const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showAddUserPassword, setShowAddUserPassword] = useState(false);

  const togglePasswordVisibilityAdornment = (visible, setVisible) => ({
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          aria-label={visible ? "Hide password" : "Show password"}
          onClick={() => setVisible((v) => !v)}
          onMouseDown={(e) => e.preventDefault()}
          edge="end"
          size="small"
        >
          {visible ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </IconButton>
      </InputAdornment>
    ),
  });





  return (
    <>
      <Navbar />

      <div className="profile-page">
        <div className="profile-wrapper">
        {/* Upload photo section on the left */}
        {activeTab === "profile" && (
        <Box className="profile-sidebar-col">
          <Paper className="profile-picture-card" elevation={3}>
            <Avatar
              alt="Profile Picture"
              src={
                profilePicUrl
                  ? profileImageSrc(profilePicUrl, avatarCacheKey)
                  : "https://via.placeholder.com/150"
              }
              sx={{ width: 100, height: 100, marginBottom: "10px" }}
            />
          <Button
              variant="outlined"
              size="medium"
              component="label"
              className="profile-btn-upload"
            >
              Upload photo
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(event) => handleImageUpload(event, "profile")}
              />
            </Button>
          </Paper>
        </Box>
        )}
        {/* Profile information section on the left */}

        {/* Main content on the right */}
        <Box className="profile-main-col" sx={{ flex: 1, minWidth: 0 }}>
          {/* Buttons for switching tabs */}
          {userRole === "admin" && (
            <div
              className="profile-segmented"
              role="tablist"
              aria-label="Admin sections"
            >
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === "profile"}
                className={`profile-segment${activeTab === "profile" ? " is-active" : ""}`}
                onClick={() => setActiveTab("profile")}
              >
                Edit profile
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === "addUser"}
                className={`profile-segment${activeTab === "addUser" ? " is-active" : ""}`}
                onClick={() => setActiveTab("addUser")}
              >
                Add user
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={activeTab === "allUsers"}
                className={`profile-segment${activeTab === "allUsers" ? " is-active" : ""}`}
                onClick={() => setActiveTab("allUsers")}
              >
                All users
              </button>
            </div>
          )}

          {/* Forms */}
          {activeTab === "profile" ? (
            <Paper className="profile-info-card" elevation={3}>
              <Typography variant="h5" gutterBottom>
                Edit Profile
              </Typography>
              <div className="form-grid">
                {[
                  { label: "Name", name: "name", type: "text" },
                  { label: "Email", name: "email", type: "email" },
                  { label: "Designation", name: "designation", type: "text" },
                  { label: "Gender", name: "gender", type: "text" },
                  { label: "Address", name: "address", type: "text" },
                  { label: "Contact No", name: "contact_no", type: "text" },
                ].map((field) => (
                  <TextField
                    key={field.name}
                    fullWidth
                    variant="outlined"
                    label={field.label}
                    name={field.name}
                    type={field.type}
                    onFocus={field.onFocus}
                    value={profile[field.name]}
                    onChange={handleProfileChange}
                    className="form-input profile-field"
                    margin="dense"
                  />
                ))}
              </div>

              {showPasswordFields && (
                <div className="form-grid profile-password-grid">
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="New password"
                    name="newpassword"
                    type={showNewPassword ? "text" : "password"}
                    value={profile.newpassword || ""}
                    onChange={handleProfileChange}
                    className="form-input profile-field"
                    margin="dense"
                    InputProps={togglePasswordVisibilityAdornment(
                      showNewPassword,
                      setShowNewPassword
                    )}
                    autoComplete="new-password"
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Confirm password"
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    value={profile.confirmPassword || ""}
                    onChange={handleProfileChange}
                    className="form-input profile-field"
                    margin="dense"
                    InputProps={togglePasswordVisibilityAdornment(
                      showConfirmPassword,
                      setShowConfirmPassword
                    )}
                    autoComplete="new-password"
                  />
                </div>
              )}

              <div className="profile-form-footer">
                <Button
                  variant="text"
                  className="profile-btn-ghost"
                  onClick={() => {
                    if (showPasswordFields) {
                      setShowNewPassword(false);
                      setShowConfirmPassword(false);
                    }
                    setShowPasswordFields(!showPasswordFields);
                  }}
                >
                  {showPasswordFields ? "Cancel password change" : "Change password"}
                </Button>
                <Button
                  variant="contained"
                  disableElevation
                  className="profile-btn-primary"
                  onClick={handleSaveProfile}
                >
                  Save changes
                </Button>
              </div>
            </Paper>
          ) : activeTab === "addUser" ? (
                <Paper className="profile-info-card" elevation={3}>
                  {/* Add New User form */}
                  <Typography variant="h5" gutterBottom>
                    Add New User
                  </Typography>
                  <div className="form-grid">
                  {[
                  { label: "Name", name: "name", type: "text" },
                  { label: "Email", name: "email", type: "email" },
                  { label: "Password", name: "password", type: "password" },
                ].map((field) => (
                      <TextField
                        key={field.name}
                        fullWidth
                        variant="outlined"
                        label={field.label}
                        name={field.name}
                        type={
                          field.name === "password"
                            ? showAddUserPassword
                              ? "text"
                              : "password"
                            : field.type
                        }
                        value={newUser[field.name]}
                        onChange={handleNewUserChange}
                        className="form-input profile-field"
                        margin="dense"
                        InputProps={
                          field.name === "password"
                            ? togglePasswordVisibilityAdornment(
                                showAddUserPassword,
                                setShowAddUserPassword
                              )
                            : undefined
                        }
                        autoComplete={
                          field.name === "password" ? "new-password" : undefined
                        }
                      />
                    ))}
                    {/* Role Dropdown */}
                      <FormControl fullWidth variant="outlined" margin="dense" className="profile-field">
                        <InputLabel id="role-label">Role</InputLabel>
                        <Select
                          labelId="role-label"
                          id="role"
                          name="access_role"
                          value={newUser.access_role}
                          onChange={handleNewUserChange}
                          label="Role"
                        >
                          <MenuItem value="general">General</MenuItem>
                          <MenuItem value="admin">Admin</MenuItem>
                        </Select>
                      </FormControl>

                  </div>
                  
                  <div className="profile-form-footer profile-form-footer--single">
                    <Button
                      variant="contained"
                      disableElevation
                      className="profile-btn-primary"
                      onClick={handleAddUser}
                    >
                      Create user
                    </Button>
                  </div>
                </Paper>
              ) : (
                <Paper className="profile-info-card" elevation={3}>
                  {/* All Users Table */}
                  <Typography variant="h5" gutterBottom>
                    All Users
                  </Typography>
                  <div className="profile-table-wrap">
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Designation</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Gender</TableCell>
                        <TableCell>Contact No</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {users.map((user) => (
                        <TableRow key={user.id}>
                          {/* <TableCell>
                            {user.access_role === "general" && (
                            <Checkbox
                              checked={selectedUsers.includes(user.user_id)}
                              onChange={() => handleSelectUser(user.user_id)}
                            />
                          )}
                        </TableCell> */}
                          <TableCell>{user.name|| ""}</TableCell>
                          <TableCell>{user.email|| ""}</TableCell>
                          <TableCell>{user.designation=== null? "" : user.designation}</TableCell>
                          <TableCell>{user.access_role|| ""}</TableCell>
                          <TableCell>{user.gender === "null"? " " : user.gender}</TableCell>
                          <TableCell>{user.contact_no ==="null"? " " : user.contact_no}</TableCell>
                          <TableCell>{user.address === "null"? " " : user.address}</TableCell>
                          <TableCell align="right">
                              {user.access_role === "general" && (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  className="profile-btn-danger"
                                  onClick={() => handleDeleteUser(user.user_id)}
                                >
                                  Remove
                                </Button>
                              )}
                            </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  </div>
                </Paper>
              )}
         </Box>
        </div>
      </div>
    </>
  );
}
